import { PageRequest } from '@/core/request/PageRequest';
import { SenderType } from '../MailConfigurationController/MailConfigurationController.types';
import { MailTypeEnum } from '../MailHistory/MailHistory.types';

export type MailAttachments = {
  content: string;
  fileName: string;
  contentType: ContentType;
}[];

export enum MailMessageType {
  Text = 'TEXT',
  Html = 'HTML',
}

export enum ContentType {
  pdf = 'PDF',
  csv = 'CSV',
}

export interface Mail {
  attachments?: MailAttachments;
  from?: string;
  fromName: string;
  id: string;
  mailType: MailTypeEnum;
  message: string;
  messageType: MailMessageType;
  senderId: string;
  sender: SenderType;
  sentDate: string;
  subject: string;
  to: string;
  userId: string;
  workorderId: string;
}

export type MailListRequestParams = PageRequest & {
  senderId?: number;
  subject?: string;
  userId?: number;
  workorderId?: number;
};

export type MailSendingRequestParams = Omit<Mail, 'id' | 'sentDate'>;

export interface MailSendingForm extends MailSendingRequestParams {
  sendWorkorder: boolean;
  attachment: string;
}

export enum SendPurchaseEnum {
  none = 'none',
  withAdditionalData = 'withAdditionalData',
  withoutAdditionalData = 'withoutAdditionalData',
}

export interface PurchaseMailSendingForm extends MailSendingRequestParams {
  sendPurchase: SendPurchaseEnum;
  attachment: string;
}

export interface PurchaseMailAttachments {
  content?: string;
  fileName?: string;
  contentType: ContentType;
}

export type PurchaseMailSendingRequestParams = Omit<
  Mail,
  'id' | 'sentDate' | 'attachments'
> & {
  attachments?: PurchaseMailAttachments[];
};
